import type { ReactNode } from 'react';

import type { BubbleProps } from '@ant-design/x';

import type { IMessage } from '@/modules/Socket';

import { StatusDot, StyledSystemMessage, StyledTime } from '../containers/ChatContainer/ChatContainerStyles';

import { formatDate, formatTime } from '@/utils';

export type TSystemBubbleItem = BubbleProps<ReactNode> & { key?: string | number };

export const buildSystemBubbleItem = (item: IMessage, key: string): TSystemBubbleItem => ({
  key,
  className: 'system-bubble',
  classNames: { content: 'system-pill-content', footer: 'system-pill-footer' },
  variant: 'borderless',
  placement: 'start',
  content: (
    <StyledSystemMessage $tone={item.tone ?? 'neutral'}>
      <StatusDot $tone={item.tone ?? 'neutral'} />
      {item.message}
    </StyledSystemMessage>
  ),
  footer: item.date && <StyledTime dateTime={formatDate(item.date)}>{formatTime(item.date)}</StyledTime>,
});
